import React from 'react'
import TimelineAssetMediaPlayer from './TimelineAssetMediaPlayer'

export const MediaPlayers = ({ renderingAssetsProps }) => (
  <>
    {renderingAssetsProps.map(props => <TimelineAssetMediaPlayer {...props} />)}
  </>
)
